import React, {useEffect, useState} from "react";
import {AddMenuStyles, CategoryBody, FakeTabelBody, TableRowsWrapper} from "./MenuManagement.styles";
import {useForm} from "components/molecules/Form";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import Button from "components/molecules/Button";
import {arrayMove, sortableContainer, sortableElement, sortableHandle} from "react-sortable-hoc";
import {ChoiceWrapper} from "components/atoms/MenuManagement/ChoiceGroup/ChoiceGroup.styles";
import handel from "assets/dragHandel.svg";
import {useAuthContext} from "Context/authContext";
import Toast from "components/molecules/Toast";
import menuStoreService from "services/menu-storeService";
import {useSelector} from "react-redux";

const DragHandle = sortableHandle(() => (
    <div className="fake-table-resp " style={{userSelect: "none"}}>
        <div
            className=""
            style={{
                marginRight: "10px",
                cursor: "move",
                flexShrink: "0",
            }}>
            <img src={handel} alt="handel" />
        </div>
    </div>
));
const SortableItem = sortableElement(({item, index, ...rest}) => (
    <FakeTabelBody key={index} $category>
        <DragHandle />
        <div className="fake-table-resp" style={{userSelect: "none"}}>
            <span className="thead-row" style={{userSelect: "none"}}>
                Available Choices
            </span>
            <div className="choices">{item?.position}</div>
        </div>
        <div className="fake-table-resp" style={{userSelect: "none"}}>
            <span className="thead-row" style={{userSelect: "none"}}>
                Unavailable Choices
            </span>
            <div className="choices">
                <div className="choices">{item?.category}</div>
            </div>
        </div>
    </FakeTabelBody>
));
const SortableContainer = sortableContainer(({children}) => {
    return <TableRowsWrapper>{children}</TableRowsWrapper>;
});

const AddCategory = ({editCategory, onClose, menuId, categoryData, handleItemModal}) => {
    const [form] = useForm();
    const {refetch} = useAuthContext();
    const defaultStore = useSelector(state => state.business.defaultStore);
    const [loading, setLoading] = useState(false);

    const list = [
        {
            position: ["BBQ sauce"],
            category: ["BBQ sauce"],
        },
        {
            position: ["BBQ sauce"],
            category: ["BBQ sauce"],
        },
        {
            position: ["BBQ sauce"],
            category: ["BBQ sauce"],
        },
    ];
    const [product, setProduct] = useState(list);

    useEffect(() => {
        if (categoryData) {
            form.setFieldsValue({
                category_name: categoryData?.name,
                category_desc: categoryData?.description,
            });
        }
    }, [categoryData]);

    const onSortEnd = ({oldIndex, newIndex}) => {
        setProduct(prevState => arrayMove(prevState, oldIndex, newIndex));
        // handelApi(arrayMove(product, oldIndex, newIndex), rowData?.categoryName);
    };
    const handleSubmit = async data => {
        try {
            setLoading(true);
            if (!menuId) {
                return Toast({
                    type: "error",
                    message: "Kindly create a menu first",
                });
            }

            const payload = {
                name: data?.category_name,
                description: data?.category_desc,
                menuId,
                branch: defaultStore,
            };
            if (!editCategory) {
                const response = await menuStoreService.createCategory(payload);
                // Pass the newly created category ID to the item modal
                const newCategoryId = response?.categoryId || response?.data?._id || response?._id;
                
                // Close the category modal first
                onClose();
                
                // Don't use global refetch as it might cause page refresh
                // Instead, let the AddNewItem component handle the refresh via its own mechanism
                
                // Open item modal immediately - the AddNewItem will get fresh data
                handleItemModal(newCategoryId);
            } else {
                await menuStoreService.updateCategory(payload, categoryData?._id);
                refetch(); // Refresh categories data after update
                onClose();
            }
            setLoading(false);
        } catch (error) {
            Toast({
                type: "error",
                message: error?.message,
            });
            setLoading(false);
        }
    };
    return (
        <AddMenuStyles>
            <Form form={form} onSubmit={handleSubmit}>
                <div className="combine-fields">
                    <Form.Item
                        label="Category Name *"
                        type="text"
                        rounded
                        name="category_name"
                        lg
                        placeholder="Enter Category name"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Category name is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                    <Form.Item
                        label="Category Description *"
                        type="text"
                        rounded
                        name="category_desc"
                        lg
                        placeholder="Enter Category description"
                        $bgWhite
                        rules={[
                            {
                                required: true,
                                message: "Category description is required",
                            },
                        ]}>
                        <Field />
                    </Form.Item>
                </div>
                {/* <hr /> */}
                {/* <strong className="title choice-detail-title">Sort Order</strong>
                <p className="choice-detail">Sort the order in which categories will display to your customers.</p>
                <CategoryBody $category>
                    <ChoiceWrapper $category>
                        <strong>Positions</strong>
                        <strong>Category</strong>
                    </ChoiceWrapper>
                    <SortableContainer onSortEnd={onSortEnd}>
                        {product?.map((item, ind) => (
                            <SortableItem item={item} index={ind} />
                        ))}
                    </SortableContainer>
                </CategoryBody> */}
                {/* <hr /> */}
                <div className="btn-holder">
                    {editCategory ? (
                        <>
                            <Button width="300px" danger type="button" onClick={() => onClose()} loader={loading}>
                                Cancel
                            </Button>

                            <Button width="300px" type="submit">
                                Save Changes
                            </Button>
                        </>
                    ) : (
                        <Button width="300px" type="submit" loader={loading}>
                            Create Category
                        </Button>
                    )}
                </div>
            </Form>
        </AddMenuStyles>
    );
};

export default AddCategory;
